const deliveryMethodsEnum = {
  HOME_DELIVERY: 'home_delivery',
  PICK_UP_FROM_STORE: 'pick_up_from_store',
  PICKUP_OR_LOCKER: 'pickup_or_locker',
};

export default deliveryMethodsEnum;

export type DeliveryMethodsEnumType = (
 | typeof deliveryMethodsEnum.HOME_DELIVERY
 | typeof deliveryMethodsEnum.PICK_UP_FROM_STORE
 | typeof deliveryMethodsEnum.PICKUP_OR_LOCKER
);
